import React from 'react';
import TenantLoginComponent from '../components/tenant/Login';

const TenantLogin: React.FC = () => {
  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-main-dark p-5">
      <TenantLoginComponent />
    </div>
  );
};

export default TenantLogin;
